
import React, { PropsWithChildren } from 'react';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';
import './CardBenefitModal.css';
import { Image, Modal, Icon } from '../../../importCL';

/* eslint-disable */
enum Version {
    Icon = 'icon',
    Image = 'image'
}
/* eslint-enable */

interface IBenefitItem {
    title?: string;
    subTitle?: string;
    imgPath?: string;
    imgAltText?: string;
    iconUuid?: string;
    iconPath?: string;
    iconAltText?: string;
}

export interface ICardBenefitModalProps {
    modalIsOpen: any
    setModalIsOpen: any
    benefitItem: IBenefitItem;
    index: number;
    setCurrentIndex: any;
    version: Version;
}

export const CardBenefitModalEditConfig = {
    emptyLabel: 'Card Benefit Modal',
    isEmpty: (props: PropsWithChildren<ICardBenefitModalProps>) => {
        return !props || !props.benefitItem;
    },
};

export default function CardBenefitModal(props: PropsWithChildren<ICardBenefitModalProps>) {
    return (
        <Modal isOpen={props.modalIsOpen} modalOpen={props.setModalIsOpen} className='CardBenefitModal'>
            <div className='CardBenefitModal__items'>
                { props.version && 
                    <div className='CardBenefitModal__picture'>
                        {   props.version === Version.Image ?
                            <Image loading='lazy' src={props.benefitItem.imgPath} alt={props.benefitItem.imgAltText} /> :
                            <Icon loading='lazy' alt={props.benefitItem.iconAltText} src={props.benefitItem.iconPath} /> 
                        }
                    </div>
                }
                { props.benefitItem && 
                    <div>
                        <div className='CardBenefitModal__title'> {transformHTMLParserLinks(props.benefitItem.title ? props.benefitItem.title : '')} </div>
                        <div> {transformHTMLParserLinks(props.benefitItem.subTitle ? props.benefitItem.subTitle : '')} </div>
                    </div>
                }
            </div>
        </Modal>
    );
}
        